import React from 'react';
import { InputProps } from '@material-ui/core';
import { UseFormMethods } from 'react-hook-form';
import { MuiAutocompleteProps, RHFAutocomplete } from '../index';

type RHFAutocompleteMultiFieldProps<T> = MuiAutocompleteProps<T> & {
  /** Handler for when an Autocomplete option has been selected */
  handleAutocompleteField: (value: T) => unknown;
  /** Handler for when text has changed inside the Autocomplete field */
  handleAutocompletePrimitive: (value: string) => unknown;
  handleClearFields: () => unknown;
  name: string;
  margin?: InputProps['margin'];
  required: boolean;
  label: string;
  control: UseFormMethods['control'];
  errors: UseFormMethods['errors'];
};

/**
 * Autocomplete component to be used with multi-field inputs.
 * Multi-field means that selecting an option from the Autocomplete will affect
 * the remaining fields.
 * */
export const RHFAutocompleteMultiField = <T, >({
  handleAutocompleteField,
  handleAutocompletePrimitive,
  handleClearFields,
  margin,
  required,
  name,
  label,
  control,
  errors,
  ...props
}: RHFAutocompleteMultiFieldProps<T>) => (
  <RHFAutocomplete
    {...props}
    name={name}
    label={label}
    InputProps={{
      margin,
      required,
      onChange: (event) => handleAutocompletePrimitive(event.target.value),
    }}
    onChange={(_, value) => {
      if (typeof value === 'string' || !value) {
        return;
      }

      handleAutocompleteField(value as any);
    }}
    onInputChange={(event, value, reason) => {
      if (reason === 'clear') {
        handleClearFields();
      }
    }}
    control={control}
    errors={errors}
  />
  );
